const width = 750;
const height = 1220;

const state = {
  scale: 1, // 设置全屏的比例
  width,
  height
};

const mutations = {
  SET_CONFIG(state, payload) {
    Object.assign(state, payload);
  }
};

const actions = {
  setSpaceSize({ commit }) {
    const { w, h, scale } = setPageSize();
    commit("SET_CONFIG", {
      width: w,
      height: h,
      scale
    });
  }
};

export default {
  state,
  mutations,
  actions
};

// 设置内容区间
function setPageSize() {
  const d = document;
  const winWidth = d.documentElement.clientWidth || d.body.clientWidth;
  const winHeight = d.documentElement.clientHeight || d.body.clientHeight;
  let scale = (winHeight * width) / winWidth / height;
  scale = scale > 1 ? scale : 1 / scale;
  let targetHeight = (height * winWidth) / width;
  let targetWidth = winWidth;
  if (targetHeight > winHeight) {
    targetHeight = winHeight;
    targetWidth = (width * winHeight) / height;
  }
  return {
    w: targetWidth,
    h: targetHeight,
    scale
  };
}
